<br>
<div class="row">
  <div class="col-sm-3">
    <mat-form-field style="display:flex;flex-direction: column">
      <mat-label>Sport</mat-label>
      <mat-select [(ngModel)]="search.sportTypeId">
        <mat-option>--SELECT--</mat-option>
        <mat-option *ngFor="let item of sportTypeList" [value]="item.id">
          {{item.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-sm-3">
    <button class="mb-2" mat-raised-button color="primary" (click)="searchSeasonSummary()">
      Search
    </button>
  </div>
  <div class="col-sm-3">

  </div>
  
</div>
<div style="width: 100%;">
  <table mat-table mat-table matSort matSortActive="sportSeason" matSortDirection="asc" matSortDisableClear [dataSource]="dataSource" style="width: 100%;">
    <ng-container matColumnDef="sportSeason">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> Season </th>
      <td mat-cell *matCellDef="let element">
        {{element.sportSeason}}
      </td>
    </ng-container>
    <ng-container matColumnDef="sportType">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> Sport </th>
      <td mat-cell *matCellDef="let element">
        {{element.sportType}}
      </td>
    </ng-container>
    <ng-container matColumnDef="institution">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> Institution </th>
      <td mat-cell *matCellDef="let element"> {{element.institution}}</td>
    </ng-container>
    <ng-container matColumnDef="freshmanQualifierType">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> FTR </th>
      <td mat-cell *matCellDef="let element"> {{element.freshmanQualifierType}} </td>
    </ng-container>
    <ng-container matColumnDef="aid">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> Aid % </th>
      <td mat-cell *matCellDef="let element">{{element.aidPercentage | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="hasSummerAid">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> Summer Aid </th>
      <td mat-cell *matCellDef="let element"> {{element.hasSummerAid? 'Yes':'No'}}</td>
    </ng-container>
    <ng-container matColumnDef="eligibility">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> Eligibility </th>
      <td mat-cell *matCellDef="let element"> {{element.eligibility}} </td>
    </ng-container>
    <ng-container matColumnDef="aidExempt">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> Aid Exempt </th>
      <td mat-cell *matCellDef="let element"> {{element.aidExempt}} </td>
    </ng-container>
    <ng-container matColumnDef="isMedicalHardship">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> Hard Ship </th>
      <td mat-cell *matCellDef="let element"> {{element.isMedicalHardship? 'Yes':'No'}} </td>
    </ng-container>
    <ng-container matColumnDef="redShirtType">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> Red Shirt </th>
      <td mat-cell *matCellDef="let element"> {{element.redShirtType}} </td>
    </ng-container>
    <ng-container matColumnDef="isNinthSemester">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> 9th Sem </th>
      <td mat-cell *matCellDef="let element"> {{element.isNinthSemester? 'Yes':'No'}} </td>
    </ng-container>
    <ng-container matColumnDef="participation">
      <th mat-header-cell mat-sort-header *matHeaderCellDef mat-sort-header> Participation </th>
      <td mat-cell *matCellDef="let element"> {{element.participation}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
</div>
